export { MappingType } from '@gm2/common';
